import { Download, Music, MapPin, Star } from 'lucide-react'
import { DJ_BIO_LONG, DJ_GENRE, DJ_STATS } from '../data'

export default function Epk() {
  return (
    <main style={{ minHeight: '100vh', padding: 'clamp(48px, 8vw, 80px) clamp(16px, 5vw, 32px)' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            marginBottom: '64px',
            paddingBottom: '24px',
            borderBottom: '1px solid var(--border)',
            gap: '24px',
            flexWrap: 'wrap',
          }}
        >
          <div>
            <div className="section-label">Press & Promoters</div>
            <h1 className="section-title">Electronic Press Kit</h1>
          </div>
          <button
            className="btn-primary"
            style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}
          >
            <Download size={14} />
            Download Full EPK (PDF)
          </button>
        </div>

        {/* Stats row */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '1px',
            background: 'var(--border)',
            marginBottom: '64px',
          }}
        >
          {DJ_STATS.map((stat) => (
            <div
              key={stat.label}
              style={{
                background: 'var(--ink-2)',
                padding: '28px 24px',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 700,
                  fontSize: '42px',
                  color: 'var(--gold)',
                  lineHeight: 1,
                  marginBottom: '8px',
                }}
              >
                {stat.value}
              </div>
              <div
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '3px',
                  textTransform: 'uppercase',
                  color: 'var(--gold-dim)',
                }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Bio */}
        <section style={{ marginBottom: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
            <Music size={16} color="var(--gold)" />
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 600,
                fontSize: '18px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: 'var(--cream)',
              }}
            >
              Biography
            </h2>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {DJ_BIO_LONG.split('\n\n').map((para, i) => (
              <p key={i} style={{ fontSize: '15px', lineHeight: 1.85, color: 'var(--muted)' }}>
                {para}
              </p>
            ))}
          </div>
        </section>

        {/* Genre */}
        <section style={{ marginBottom: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <Star size={16} color="var(--gold)" />
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 600,
                fontSize: '18px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: 'var(--cream)',
              }}
            >
              Genre & Style
            </h2>
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {DJ_GENRE.map((g) => (
              <span
                key={g}
                style={{
                  fontFamily: 'var(--font-display)',
                  fontSize: '10px',
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                  color: 'var(--gold)',
                  border: '1px solid rgba(200,169,110,0.3)',
                  padding: '6px 14px',
                }}
              >
                {g}
              </span>
            ))}
          </div>
        </section>

        {/* Notable events */}
        <section style={{ marginBottom: '56px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <MapPin size={16} color="var(--gold)" />
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 600,
                fontSize: '18px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: 'var(--cream)',
              }}
            >
              Notable Events & Venues
            </h2>
          </div>
          <ul
            style={{
              listStyle: 'none',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px 32px',
            }}
          >
            {[
              'Rock the Country Tour (2024 & 2025)',
              'Stagecoach Festival — Indio, CA',
              'Country Thunder — Multiple Markets',
              'EDC Las Vegas',
              'Barefoot Country Music Fest',
              'Carolina Country Music Fest',
              'Billboard Country Live',
              'Moonshine Beach — San Diego',
            ].map((venue) => (
              <li
                key={venue}
                style={{
                  fontSize: '13px',
                  color: 'var(--muted)',
                  paddingLeft: '16px',
                  position: 'relative',
                  lineHeight: 1.6,
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: '0.55em',
                    width: '4px',
                    height: '4px',
                    borderRadius: '50%',
                    background: 'var(--gold-dim)',
                  }}
                />
                {venue}
              </li>
            ))}
          </ul>
        </section>

        {/* Download CTA */}
        <div
          style={{
            border: '1px solid var(--border)',
            padding: '40px',
            textAlign: 'center',
            background: 'var(--ink-2)',
          }}
        >
          <h3
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: '28px',
              textTransform: 'uppercase',
              color: 'var(--cream)',
              marginBottom: '12px',
            }}
          >
            Full Press Kit Available
          </h3>
          <p style={{ color: 'var(--muted)', marginBottom: '28px', fontSize: '14px' }}>
            Includes hi-res photos, full bio, rider, stage plot, and social stats.
          </p>
          <button className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            <Download size={14} />
            Download EPK (PDF)
          </button>
        </div>
      </div>
    </main>
  )
}
